import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import "./Courses.css";


export const CourseCard = ({ categoryType, titleText, summaryText, imageurl, courseURL, courseDuration }) => {

    const title = titleText || "Title";
    const summary = summaryText || "This is a summary on the article";
    const category = categoryType || "Exercise Category";
    const duration = courseDuration || 16.4;
    let imageLocation = imageurl || ""
    const courseLocation = courseURL || "/home"
    const navigate = useNavigate();

    const sendtoCourse = async () => {
        //window.location.href= courseLocation;
    };

    return(
        <div className="course-card-container" onClick={sendtoCourse}> 
            <div className="course-image-container"> 
                <img className="course-image" src={imageLocation} />
            </div>
            <div className="course-card-content-container"> 
                <div className="course-text-container"> 
                    <div className="course-category-text"> 
                        <p>{category}</p>
                    </div>
                    <p>Presented by: {duration}</p>
                    <div className="course-heading-subheading-container">
                        <div className="course-heading-container"> 
                            <div className="course-heading"> 
                                <p>{title}</p>
                            </div>
                            <div className="course-heading-icon-container"> 
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="course-heading-icon" />
                            </div>
                        </div>
                        <div className="course-subheading-container"> 
                            <div className="course-subheading">
                                <p className="course-subheading-text">{summary}</p>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}